import { AxiosResponse } from 'axios'
import {
  ActiveEngagementPerCareArticleResponse,
  ActiveEngagementPerLearnArticleResponse,
  ActiveEngagementPerLessonResponse,
  ActiveEngagementPerQueryResponse,
  ActiveEngagementPerQuestionnaireResponse,
  ActiveEngagementPerTipResponse,
  ActiveEngagementPerUserResponse,
  BaseTableRequest,
  CourseEngagementPerUser,
  EngagementPerSessionResponse,
  EngagementPerUserCertificateResponse,
  EngagementPerUserSearchesResponse,
  LessonEngagementPerUser,
  QueryEngagementPerUser,
  QuizzesResponse,
  ReportRequestSessionDetail,
  ReportRequestWithDate,
  ReportSessionDetail,
  Response,
  SearchesResponse,
  SharedContentResponse,
  SharedPerUserResponse,
  TableResponse,
  TotalEngagementPerOrgUsersResponse,
  TotalEngagementPerUserResponse,
  ViewCountOfLessonsResponse,
} from 'types'
import axiosInstance from './axios'

export const getViewCountOfLessonsReport = async (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, ViewCountOfLessonsResponse>(
    '/reports/view-count-of-lessons',
    request,
  )
}

export const getCourseEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TableResponse<CourseEngagementPerUser>>(
    '/reports/course-engagement-per-user',
    request,
  )
}

export const getLessonEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TableResponse<LessonEngagementPerUser>>(
    '/reports/lesson-engagement-per-user',
    request,
  )
}

export const getLearnLibraryEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerUserResponse>(
    '/reports/learn-article-engagement-per-user',
    request,
  )
}

export const getCareArticlesEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerUserResponse>(
    '/reports/care-article-engagement-per-user',
    request,
  )
}

export const getQueryEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TableResponse<QueryEngagementPerUser>>(
    '/reports/query-engagement-per-user',
    request,
  )
}

export const getTotalEngagementPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TotalEngagementPerUserResponse>(
    '/reports/total-engagement-per-user',
    request,
  )
}

export const getTotalEngagementPerOrgUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TotalEngagementPerOrgUsersResponse>(
    '/reports/total-engagement-per-org-user',
    request,
  )
}

export const getLoginPerOrgUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, TotalEngagementPerOrgUsersResponse>(
    '/reports/active-engagement-per-session/org-user/master',
    request,
  )
}

export const generateRecords = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<ReportRequestWithDate, AxiosResponse<ArrayBuffer>>(
    '/reports/generate-records',
    request,
    {
      responseType: 'arraybuffer',
    },
  )
}

export const getEngagementPerSessionReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, EngagementPerSessionResponse>(
    '/reports/active-engagement-per-session/master',
    request,
  )
}

export const getEngagementPerSessionDetailReport = async (request: ReportRequestSessionDetail) => {
  return axiosInstance.post<ReportRequestSessionDetail, Response<ReportSessionDetail>>(
    '/reports/active-engagement-per-session/detail',
    request,
  )
}

export const getActiveEngagementPerLessonReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerLessonResponse>(
    '/reports/active-engagement-per-lesson',
    request,
  )
}

export const getActiveEngagementPerLearnArticleReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerLearnArticleResponse>(
    '/reports/active-engagement-per-learn-article',
    request,
  )
}

export const getActiveEngagementPerCareArticleReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerCareArticleResponse>(
    '/reports/active-engagement-per-care-article',
    request,
  )
}

export const getActiveEngagementQuestionnaireReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerQuestionnaireResponse>(
    '/reports/active-engagement-per-questionnaire',
    request,
  )
}

export const getActiveEngagementQueryReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerQueryResponse>(
    '/reports/active-engagement-per-query',
    request,
  )
}

export const getActiveEngagementPerTipReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, ActiveEngagementPerTipResponse>(
    '/reports/active-engagement-per-tip',
    request,
  )
}

export const getQuizzesReport = async (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, QuizzesResponse>('/reports/quizzes', request)
}

export const getSearchesPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, EngagementPerUserSearchesResponse>(
    '/timelines/search-histories-report',
    request,
  )
}

export const getCertificatesPerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, EngagementPerUserCertificateResponse>(
    '/certificates/report',
    request,
  )
}

export const getQuestionnaireReport = async (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, QuizzesResponse>('/reports/questionnaires', request)
}

export const getSearchReport = async (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, SearchesResponse>(
    '/timelines/search-histories',
    request,
  )
}

export const getSharedContentReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, SharedContentResponse>(
    '/reports/share-count-of-content-share',
    request,
  )
}

export const getShareCountPerContentReport = async (request: BaseTableRequest) => {
  return axiosInstance.post<BaseTableRequest, SharedContentResponse>(
    '/reports/active-share-count-per-content-share',
    request,
  )
}

export const getSharePerUserReport = async (request: ReportRequestWithDate) => {
  return axiosInstance.post<BaseTableRequest, SharedPerUserResponse>(
    '/reports/content-share-per-user',
    request,
  )
}
